import { useEffect, useMemo, useState } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import { getIcs2ArrivalHistory } from 'store/declarations/eu/ics2/arrival/client';
import { ICS2ArrivalHistoryEntry } from 'store/declarations/eu/ics2/arrival/ics2-arrival-notification-declaration';
import { ArrivalNotificationOutletContext } from './ArrivalNotificationPage';

export interface ArrivalNotificationHistoryOutletContext extends ArrivalNotificationOutletContext {
    history: ICS2ArrivalHistoryEntry[];
}

const ArrivalNotificationHistory = () => {
    const pageContext = useOutletContext<ArrivalNotificationOutletContext>();
    const { arrival, messages } = pageContext;
    const [history, setHistory] = useState<ICS2ArrivalHistoryEntry[]>([]);

    useEffect(() => {
        if (!arrival?.id) return;

        getIcs2ArrivalHistory(arrival.id)
            .then(setHistory)
            .catch(() => {
                /* The timeline is supporting detail; failing to load it leaves the table empty. */
            });
    }, [arrival?.id, arrival?.version, arrival?.status, messages.length]);

    const context: ArrivalNotificationHistoryOutletContext = useMemo(
        () => ({ ...pageContext, history }),
        [pageContext, history]
    );

    return <Outlet context={context} />;
};

export default ArrivalNotificationHistory;
